module.exports = __webpack_public_path__ + "static/media/Left legs16.6dc82474.png";